<template>
  <div class="mt-5 mx-10">
    <v-row>
      <v-col class="d-flex justify-center">
        <h1>{{ $t('admin.menu.commands_list') }}</h1>
        <v-btn color="primary" style="width: max-content; min-width: 30px !important" @click="sendCommandModal"
          ><v-icon>mdi-send-check-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <template>
      <div v-if="commands.length === 0">
        <v-autocomplete prepend-icon="mdi-loading mdi-spin" :label="$t('device.form.loading')"></v-autocomplete>
      </div>
      <v-data-table
        v-if="commands.length > 0"
        :headers="commandsHeader"
        data-cy="commandsTable"
        :items="commands"
        :search="search"
        item-key="iccid"
        :items-per-page="10"
        sort-by="sent_by"
        :custom-sort="customSort"
        class="sim-table table-cursor elevation-1"
        cursor="pointer"
        style="overflow: auto; overflow-x: hidden; min-height: 100px; max-height: 750px">
        <template v-slot:top>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('admin.commands.search_commands')"
            single-line
            hide-details
            prepend-inner-icon=" "></v-text-field>
        </template>

        <template v-slot:[`item.sent`]="{ item }">
          {{ formatDate(item.sent) }}
        </template>

        <template v-slot:[`item.received`]="{ item }">
          {{ formatDate(item.received) }}
        </template>

        <template v-slot:[`item.device_sn`]="{ item }">
          <a href="#" @click="editDevice(item)">
            {{ item.device_sn }}
          </a>
        </template>
      </v-data-table>
    </template>

    <div class="mb-5" style="display: flex; align-items: center; justify-content: center">
      <CommandModal v-if="isActive" ref="modalTask" @closeMaintenanceDialog="isActive = false" />
    </div>

    <br />
  </div>
</template>
<script>
import router from '../../../plugins/router/index';
import { getDevice } from '../../../viewModels/adminViewModel.js';
import CommandModal from '../../../components/forms/commandsModal.vue';
import { getCommands } from '../../../viewModels/commandsViewModel.js';

export default {
  components: {
    CommandModal,
  },

  data() {
    return {
      search: '',
      isActive: false,
      commands: [],
    };
  },

  async mounted() {
    this.commands = await getCommands();
  },

  methods: {
    sendCommandModal: function () {
      this.isActive = true;
      setTimeout(() => {
        this.$refs.modalTask.setActiveModal(true);
      }, 100);
    },

    editDevice: async function (e) {
      const device = await getDevice(e.device_sn);
      router.push({
        name: 'editDevice',
        params: { device_sn: e.device_sn, deviceData: device },
      });
    },

    formatDate(date) {
      if (!date) return;
      date = date.replace('.000Z', '');
      let minute = new Date(date).getMinutes();
      if (minute.toString().length < 2) minute = '0' + minute;
      let hour = new Date(date).getHours();
      if (hour.toString().length < 2) hour = '0' + hour;
      let day = new Date(date).getDate();
      if (day.toString().length < 2) day = '0' + day;
      let month = new Date(date).getMonth() + 1;
      if (month.toString().length < 2) month = '0' + month;
      let year = new Date(date).getFullYear();

      let formatedDate = `${day}/${month}/${year} - ${hour}:${minute}`;
      return formatedDate;
    },

    customSort(items, sortBy, sortDesc) {
      if (!sortBy.length) return items;
      const key = sortBy[0];
      const desc = sortDesc[0];
      return items.sort((a, b) => {
        let aVal = a[key];
        let bVal = b[key];

        // sent_by ordenamos alfabéticamente
        if (key === 'sent_by') {
          aVal = (aVal || '').toLowerCase();
          bVal = (bVal || '').toLowerCase();
        }

        if (bVal < aVal) return desc ? 1 : -1;
        if (bVal > aVal) return desc ? -1 : 1;
        return 0;
      });
    },
  },

  computed: {
    commandsHeader() {
      return [
        {
          text: 'SN',
          value: 'device_sn',
          width: '6rem',
          divider: true,
        },
        {
          text: this.$t('notifications.type'),
          value: 'type',
          width: '6rem',
          divider: true,
        },
        {
          text: this.$t('admin.menu.param'),
          value: 'param1' ?? 'param2',
          width: '6rem',
          divider: true,
        },
        {
          text: this.$t('dashboard.configuration.sent_by'),
          value: 'sent_by',
          width: '8rem',
          divider: true,
        },
        {
          text: this.$t('admin.menu.sent'),
          value: 'sent',
          width: '7rem',
          divider: true,
        },
        {
          text: this.$t('admin.menu.received'),
          value: 'received',
          width: '7rem',
          divider: true,
        },

        {
          text: this.$t('admin.menu.response'),
          value: 'response',
          width: '10rem',
          divider: true,
        },
        {
          text: this.$t('dashboard.details.status'),
          value: 'status',
          width: '6rem',
          divider: true,
        },
      ];
    },
  },
};
</script>
